export default __webpack_public_path__ + "static/media/menu-bottom.3abea4ac.png";